module.exports = __webpack_public_path__ + "assets/fab12bb6eff9a853d067e4b14492f27b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/Outro.mp3
 ** module id = 217
 ** module chunks = 0
 **/